import React, { ReactNode } from 'react';
import classnames from 'classnames';
import {
	DragElementWrapper,
	DragSourceOptions,
	DragSourceConnector,
	DragSourceMonitor,
	DragSource,
} from 'react-dnd';

import { TreeNode } from '../tree-layer';

type RequiredProps = {
	node: TreeNode<undefined>;
	children: ReactNode;
	className?: string;
	classWhenDragging?: string;
};

export type DragChildren = { isDragging: boolean };

type DragProps = {
	dragSource: DragElementWrapper<DragSourceOptions>;
	isDragging: boolean;
};

export type DragPayload = {
	id: string;
};

export const FILE_EXPLORER_DRAG_ID = 'FILE_EXPLORER';

//why isn't this working as a decorator?? does not work even as class decorator
export const DraggableTreeNode = DragSource<RequiredProps, DragProps, DragPayload>(
	FILE_EXPLORER_DRAG_ID,
	{
		beginDrag: ({ node }) => ({
			id: node.id,
		}),
	},
	(connect: DragSourceConnector, monitor: DragSourceMonitor): DragProps => {
		return {
			dragSource: connect.dragSource(),
			isDragging: monitor.isDragging(),
		};
	}
)(DragHandle);

function DragHandle(props: DragProps & RequiredProps) {
	const {
		dragSource,
		isDragging,
		children,
		className = 'drag-handle',
		classWhenDragging = 'dragging-handle',
	} = props;

	// ☣️ warning - dangerous syntax - do not use
	// import isFunction from 'is-function';
	// type childrenFunction = (props: DragChildren) => ReactNode;
	// const content = isFunction(children)
	// 	? (children as childrenFunction)({ isDragging })
	// 	: (children as ReactNode);
	const content = children as ReactNode;

	return dragSource(
		<div className={classnames(className, { [classWhenDragging]: isDragging })}>
			{content}
		</div>
	);
}
